import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

const apiDef = {
  validaAnaliseExigencia(tokenRecaptcha, data) {
    return http.post(
      "/MovimentacaoExterno/ValidaAnaliseExigencia",
      tokenRecaptcha,
      data
    );
  },
  postRespostaExigencia(data) {
    let formData = new FormData();
    formData.append('model', JSON.stringify(data));

    if(data?.DataGridDocumento.length > 0) {
      for (var key in data.DataGridDocumento) {
        formData.append('files', data.DataGridDocumento[key].Documento);
      }
    }

    return http.post(`/MovimentacaoExterno/PostRespostaExigencia`, formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
  },
};

export default apiDef;
